/**
 * i18n 語言包
 */
import zh_TW from './zh-TW.json'
import zh_CN from './zh-CN.json'
import en from './en.json'
import ja from './ja.json'
import ko from './ko.json'
import de from './de.json'
import es from './es.json'
import fr from './fr.json'
import it from './it.json'
import el from './el.json'
import pl from './pl.json'
import { UILangEnum } from '../enums/uiLangEnum.js'

/**
 * 提供的語言包
 * @return {Record<UILangEnum, object>}
 */
export const messages = {
  [UILangEnum.Chinese_Traditional_Taiwan]: zh_TW,
  [UILangEnum.Chinese_Simplified_China]: zh_CN,
  [UILangEnum.English]: en,
  [UILangEnum.Japanese]: ja,
  [UILangEnum.Korean]: ko,
  [UILangEnum.German]: de,
  [UILangEnum.Spanish]: es,
  [UILangEnum.French]: fr,
  [UILangEnum.Italian]: it,
  [UILangEnum.Greek]: el,
  [UILangEnum.Polish]: pl,
}

/**
 * 取得支援的語言
 * @return {string[]}
 */
export const getSupportLocales = (): string[] => Object.keys(messages)

export default messages
